// extracted by mini-css-extract-plugin
module.exports = {"container":"Upload__container__1mC0k"};